
import $ from "jquery";
import jss from 'jss'
import preset from 'jss-preset-default'
import {generateVectorPosition} from 'Client/utils/vector-position'
class WidgetPositionImageECB extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				img: ".background-img-position .img-position-item",
				title: ".editor-content-title .ecf-title-box",
				content: ".editor-content-text .content",
				sliderImage: "#editor-context-box #slider-image",
				slickPrev: "#editor-context-box #slider-image .slick-prev",
				buttonPadding: '#buttonContentPadding',
				slideItem: '#editor-context-box #slider-image .slide--video',
				playButton: "#editor-context-box #slider-image .slide--video .play-icon"
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings( 'selectors' );
		return {
			$img: this.$element.find(selectors.img),
			$title: this.$element.find(selectors.title),
			$content: this.$element.find(selectors.content),
			$sliderImage: this.$element.find(selectors.sliderImage),
			$slickPrev: this.$element.find(selectors.slickPrev),
			$buttonPadding: this.$element.find(selectors.buttonPadding),
			$slideItem: this.$element.find(selectors.slideItem),
			$playButton: this.$element.find(selectors.playButton)
		};
	}

	toggleVideo(slide, isEnable = true) {
		let video = $(slide).find('video')[0];
		if(video){
			let playButton = this.elements.$playButton;
			let enableToggle = isEnable ? !$(slide).hasClass('play') : false;

			$(slide).toggleClass('play', enableToggle);
			if ($(slide).hasClass('play')) {
				video.play();
				playButton.css('display', 'none');
			} else {
				video.pause();
				playButton.css('display', 'block');
				$(slide).find('.slide ').removeClass('play');
			}
		}
	}

	set_font_size(obj,element){
		let {title_style,des_style} = obj;
		jss.setup(preset());

		const defineStyles = [
			{
				'key': 'heading1',
				'desktop': {
					'weight': 600,
					'size': 32,
					'lineHeight': 40,
				},
				'mobile': {
					'size': 20,
					'lineHeight': 28,
				}
			},
			{
				'key': 'heading2',
				'desktop': {
					'weight': 600,
					'size': 24,
					'lineHeight': 32,
				},
				'mobile': {
					'size': 18,
					'lineHeight': 24,
				}
			},
			{
				'key': 'heading3',
				'desktop': {
					'weight': 500,
					'size': 24,
					'lineHeight': 32,
				},
				'mobile': {
					'size': 18,
					'lineHeight': 24,
				}
			},
			{
				'key': 'text1',
				'desktop': {
					'size': 18,
					'lineHeight': 28,
				},
				'mobile': {
					'size': 16,
					'lineHeight': 24,
				}
			},
			{
				'key': 'text2',
				'desktop': {
					'size': 16,
					'lineHeight': 24,
				},
				'mobile': {
					'size': 14,
					'lineHeight': 20,
				}
			}
		]
		
		const styles = {
			fontStyle:{
			}
		}
		defineStyles.forEach(function(style,i) {
			if(style.key == title_style) {
				styles['fontStyle']['font-size'] = style.desktop.size + 'px !important';
				styles['fontStyle']['font-weight'] = style.desktop.weight + ' !important';
				styles['fontStyle']['line-height'] = style.desktop.lineHeight + 'px !important';

				styles[`@media (max-width: 768px)`] = {
					fontStyle: {
						'font-size': style.mobile.size + 'px !important',
						'line-height': style.mobile.lineHeight + 'px !important'
					}
				};
			}
			if(style.key == des_style) {
				styles['fontStyle']['font-size'] = style.desktop.size + 'px !important';
				styles['fontStyle']['line-height'] = style.desktop.lineHeight + 'px !important';

				styles[`@media (max-width: 768px)`] = {
					fontStyle: {
						'font-size': style.mobile.size + 'px !important',
						'line-height': style.mobile.lineHeight + 'px !important'
					}
				};
			}
		});

		const {classes} = jss.createStyleSheet(styles).attach()
		element.classList.add(classes.fontStyle)
	}

	setButtonPadding(){
		let buttonPadding = this.elements.$buttonPadding[0];
		if(buttonPadding){
			let dataStyle = buttonPadding.getAttribute('data-style');
			let jsonPadding = '';
			jsonPadding = dataStyle && dataStyle != '' ? JSON.parse(atob(dataStyle)) : '';
			let buttonPaddingStyle = {}
			if(jsonPadding.length > 0){
				jss.setup(preset())
				jsonPadding.forEach((style) => {
					let { breakpoint, padding} = style
					if(typeof breakpoint === 'undefined'){
						buttonPaddingStyle = { ...buttonPaddingStyle, ...{padding} }
					}else if((typeof breakpoint !== 'undefined')){
						buttonPaddingStyle = { ...buttonPaddingStyle, ...{[`@media (max-width: ${breakpoint}px)`] : {padding}} }
					}
				})
				const styles = {
					buttonPadding: buttonPaddingStyle
				}
				const {classes} = jss.createStyleSheet(styles).attach()
				buttonPadding.classList.add(classes.buttonPadding)
			}
		}
	}

	bindEvents() {
		let img = this.elements.$img;
		let title = this.elements.$title[0];
		let content = this.elements.$content[0];
		let $this = this;

		if(title) {
			let dataFontSizeTitle = JSON.parse(atob(title.getAttribute('data-font')));
			$this.set_font_size(dataFontSizeTitle,title);
		}
		if(content) {
			let dataFontSizeContent = JSON.parse(atob(content.getAttribute('data-font')));
			$this.set_font_size(dataFontSizeContent,content);
		}
		
		img.each(function(index, element){
			let dataPosition = element.getAttribute('data-position');
			let dataResponsive = element.getAttribute('data-responsive');
			let defaultObj = JSON.parse(atob(dataPosition))
			let responsive = JSON.parse(atob(dataResponsive))
			generateVectorPosition(defaultObj, responsive, element); 
		});
		this.setButtonPadding();
		this.setSlider();
	}

	setSlider() {
		const THIS = this;
		let sliderElement = this.elements.$sliderImage[0];
		let slideItem = this.elements.$slideItem;
		sliderElement && $(sliderElement)
			.on('init', function(event, slick) {
				if(!$(slick.$slides).length || slick.slideCount < 2) return;

				let slideTitle = $(slick.$slides[0].querySelector('.slide-title')).outerHeight();
				let slickDots = slick.$dots[0].offsetHeight;
				let expert = slideTitle + slickDots;
				slick.$prevArrow.css('transform',`translate(-50%,calc(-50% - ${expert}px))`);
				slick.$nextArrow.css('transform',`translate(50%,calc(-50% - ${expert}px))`);
			})
			.slick({
				// initialSlide: 1,
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				arrows: true,
				variableWidth: false,
				nextArrow: '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next">Next</button>',
				prevArrow: '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev">Previous</button>',
				dots: true,
				responsive: [
				],
			}).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				let slide = slick.$slides[currentSlide];
				THIS.toggleVideo(slide, false);
			});
		slideItem.on('click', function(event) {
			THIS.toggleVideo(this);
		});
	}
}

jQuery( window ).on( 'elementor/frontend/init', () => {
	const addHandler = ( $element ) => {
		elementorFrontend.elementsHandler.addHandler( WidgetPositionImageECB, {
			$element,
		} );
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/ecf_editor_box_content.default', addHandler );
} );
